<script setup lang="ts">
import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useDisplay } from 'vuetify'

import { useDrawerStore } from '@/stores/drawer'

const navigationItems = ref([
  {
    title: 'Projects',
    icon: 'mdi-folder-multiple-outline',
    event: 'project-index'
  },
  {
    title: 'Hardware Profiles',
    icon: 'mdi-server',
    event: 'global-hardware-profiles'
  }
])

const drawerStore = useDrawerStore()
const { drawer } = storeToRefs(drawerStore)

const { smAndDown } = useDisplay()

const drawerWidth = computed(() => (drawer.value.shown ? drawer.value.width : 60))

const drawerModel = computed({
  get: () => {
    return smAndDown.value ? drawer.value.shown : true
  },
  set: (val) => {
    drawer.value.shown = val
  }
})
</script>

<template>
  <v-navigation-drawer
    v-model="drawerModel"
    :mini-variant="!smAndDown && !drawer.shown"
    :width="drawerWidth"
    :permanent="!smAndDown"
  >
    <v-list class="py-0">
      <v-list-item-title v-if="drawer.shown && !smAndDown" class="px-4 py-3 text-subtitle-1">
        CloudCompute
      </v-list-item-title>
      <v-divider></v-divider>

      <v-list-item
        v-for="item in navigationItems"
        :key="item.event"
        :to="{ name: item.event }"
        :active="$route.name === item.event"
        color="primary"
      >
        <div :class="drawer.shown ? 'd-flex align-center' : 'd-flex flex-column justify-center'">
          <v-icon style="opacity: 1" :icon="item.icon" color="primary" size="large" />
          <div v-if="drawer.shown" class="px-3">
            {{ item.title }}
          </div>
        </div>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
